import {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {Form, FormikProvider, useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from "react-toastify";
import {nanoid} from "@reduxjs/toolkit";
import {addFamily, reserveCode, updateFamily} from "../../redux/slices/family";

import {Stack, TextField, Drawer, Typography, Box} from '@mui/material';
import {LoadingButton} from "@mui/lab";


export default function FamilyCreateForm({selected, open, onClose}) {

    const isEdit = Boolean(selected);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);


    const schema = Yup.object().shape({
        label: Yup.string().required('Le nom est requis'),
        code: Yup.string().required('Le code est requis'),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            label: selected?.label || '',
            code: selected?.code || '',
            description: selected?.description || '',
        },
        validationSchema: schema,

        onSubmit: async (values, {setErrors}) => {
            try {
                setLoading(true);

                const callback = () => {
                    toast.success(`${isEdit ? 'Mise à ajour avec succès' : 'Enrégistré avec succès'}`)
                    handleClosing()
                };

                const createData = {
                    id: nanoid(),
                    ...values
                }

                const editData = {
                    id: selected?.id,
                    ...values
                }

                isEdit
                    ? dispatch(updateFamily(editData, callback))
                    : dispatch(addFamily(createData, callback))


            } catch (error) {
                setErrors({afterSumit: error.code});
                console.log(error);
                toast.error('une erreur s\'est produite ')
                handleClosing()
            }
        }
    });

    const {
        errors,
        touched,
        handleSubmit,
        getFieldProps, setFieldValue,
        resetForm,
        setSubmitting
    } = formik;

    useEffect(() => {

        if (open && !isEdit) {

            setLoading(true)
            dispatch(reserveCode((code) => {
                setFieldValue('code', code)
                setLoading(false)
            }))

        }

        // eslint-disable-next-line
    }, [open, isEdit])

    const handleClosing = () => {
        onClose && onClose()
        resetForm()
        setSubmitting(false);
        setLoading(false);
    }


    return (
        <Drawer
            anchor={'right'}
            open={open}
            onClose={handleClosing}
        >
            <Box sx={{width: 400, p: 1, pt: 10}}>
                <FormikProvider value={formik}>
                    <Form autoComplete='off' noValidate autoCapitalize='on' onSubmit={handleSubmit}>

                        <Stack spacing={3}>

                            <Typography variant={'h6'}>
                                {`${isEdit ? 'MAJ' : 'Enregistrer'} la famille`}
                            </Typography>

                            <TextField
                                fullWidth
                                label='Nom'
                                error={Boolean(touched.label && errors.label)}
                                helperText={touched.label && errors.label}
                                {...getFieldProps('label')}
                            />

                            <TextField
                                fullWidth
                                label='Code'
                                error={Boolean(touched.code && errors.code)}
                                helperText={touched.code && errors.code}
                                {...getFieldProps('code')}
                            />

                            <TextField
                                fullWidth
                                multiline
                                minRows={4}
                                label='Description'
                                error={Boolean(touched.description && errors.description)}
                                helperText={touched.description && errors.description}
                                {...getFieldProps('description')}
                            />

                            <LoadingButton
                                type='submit'
                                variant='contained'
                                loading={false}>
                                Enregistrer
                            </LoadingButton>

                        </Stack>

                    </Form>
                </FormikProvider>

            </Box>

        </Drawer>
    )
}
